<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="success"
        dark
        v-bind="attrs"
        v-on="on"
        @click="updateCertificates"
        v-if="false"
      >
        Assinar
      </v-btn>
    </template>

    <v-card>
      <v-progress-linear
        indeterminate
        fixed
        top
        :active="$store.state.loading.active"
        style="z-index: 10"
      />

      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Assinatura digital</v-toolbar-title>
      </v-toolbar>

      <v-container fluid>
        <v-row dense align="stretch">
          <v-col>
            <v-overlay :value="loadingEsign">
              <v-progress-circular indeterminate size="64" />
            </v-overlay>

            <object :data="fileUrl" type="application/pdf" width="100%" height="600">
              <embed :src="fileUrl" type="application/pdf" />
            </object>
          </v-col>

          <!-- <v-col>
            <v-row dense>
              <v-col>
                <v-select
                  label="Certificado"
                  placeholder="Selecione um certificado"
                  v-model="certificate"
                  dense
                  outlined
                  :items="certificates"
                  :item-text="
                    (item) => `${item.subjectName} - (emitido por ${item.issuerName})`
                  "
                  item-value="thumbprint"
                  :hide-details="errors.certificate === undefined"
                  :error-messages="errors.certificate"
                />
              </v-col>
            </v-row> -->

            <!-- <v-row dense>
              <v-spacer />
              <v-col cols="auto">
                <v-btn color="red" text @click="cancel" :disabled="signing">
                  cancelar
                </v-btn>
              </v-col>

              <v-col cols="auto">
                <v-btn color="success" @click="sign" :disabled="signing">
                  assinar
                </v-btn>
              </v-col>
            </v-row> -->
          <!-- </v-col> -->
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "EsignButton",
    props: {
      esign: Object,
      vDialog: {
        type: Boolean,
        default: false,
      },
      hideButton: {
        type: Boolean,
        default: false,
      },
      callback: {
        type: Function,
        default: () => {},
      },
    },
    model: {
      prop: "vDialog",
      event: "change",
    },
    data() {
      return {
        errors: {},
        certificates: [],
        certificate: "",
        Idialog: false,
        signing: false,
      };
    },
    // mounted() { //refactor when start to use digital sign
    //   this.updateCertificates();
    // },
    apollo: {
      internalEsign: {
        query: require("@/graphql/esign/esign.gql"),
        variables() {
          return {
            esignId: this.esign.id,
          };
        },
        update: (data) => data.esign,
      },
    },
    computed: {
      dialog: {
        set(value) {
          this.Idialog = value;
          this.$emit("change", value);
        },
        get() {
          return this.vDialog || this.Idialog;
        },
      },
      fileUrl() {
        if (this.internalEsign) {
          return `${process.env.VUE_APP_BASE_URL}${this.internalEsign.fileUrl}`;
        }

        return "";
      },
      showButton() {
        let status = this.esign.status !== "signed";
        if (this.internalEsign) {
          status = this.internalEsign.status !== "signed";
        }

        return status && !this.hideButton;
      },
      loadingEsign() {
        return this.$apollo.queries.internalEsign.loading;
      },
    },
    methods: {
      cancel() {
        this.dialog = false;
      },
      updateCertificates() {
        this.refetchEsign();

        this.$lacuna.listCertificates().success((certs) => {
          this.certificates = certs;
        });
      },
      refetchEsign() {
        this.$apollo.queries.internalEsign.refetch();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        if (!this.certificate) {
          this.errors.certificate = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      sign() {
        if (!this.validate()) return;

        this.signing = true;

        this.apolloMutate({
          mutation: require("@/graphql/esign/generate_bytes_to_sign.gql"),
          variables: {
            esignId: this.internalEsign.id,
          },
        }).then(({ data }) => {
          const bytesToSign = data.generateBytesToSign.token;
          console.log(bytesToSign);

          this.$lacuna
            .signWithRestPki({
              thumbprint: this.certificate,
              token: bytesToSign,
            })
            .success((signature) => {
              console.log(signature);
              this.apolloMutate({
                mutation: require("@/graphql/esign/finish_signature.gql"),
                variables: {
                  esignId: this.internalEsign.id,
                  token: signature,
                },
              })
                .then(() => {
                  this.signing = false;
                  this.dialog = false;
                  this.callback();

                  this.$store.dispatch("createNotification", {
                    message: "Assinatura realizada.",
                    type: "success",
                  });
                })
                .finally(() => {
                  this.signing = false;
                });
            })
            .error((error) => {
              console.log(error);
              this.signing = false;
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
